import "lazysizes";
import * as Components from './components/index';
import * as Widgets from './swipers/index';

jQuery(document).ready(function($){
    $('.trigger').click(function() {
        $('.slider').removeClass('close');
    });  

    $('.fas, .fa-slider').click(function() {
        $('.slider').addClass('close');
    });  

});

document.addEventListener("DOMContentLoaded", function () {
    Components.Zoom.init();
    Widgets.Productshowcase.init();
    Widgets.Products.init();
});